// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--1wqdn","containerDescription":"styles-module--containerDescription--1xm0i","containerImage":"styles-module--containerImage--1oxYD"};